import Api from '@/api/Api'

export default {
  getCSNotification (param) {
    return Api().post('UserNotification/get_cs_notification', { user_id: param })
  }
}



// WEBPACK FOOTER //
// ./src/api/UserNotificationAPI.js